import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { UPDATE_FORFAIT } from '../../Utils/constant';
import { updateOne } from '../../services/service';
import { useStoreEquipement } from '../../store/Paramettre/equipementStore';
import { useStoreForfait } from '../../store/Paramettre/forfaitStore';

export const ForfaitForm = ({ item }) => {
    const [typeEquipement, setTypeEquipement] = useState(item?.typeEquipement?.id)
    const [categorie, setCateogie] = useState(item?.categorie)
    const forfait = useStoreForfait()
    const typeEquipements = useStoreEquipement()
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const submit = (data) => {
        setIsSubmit(true)
        updateOne(UPDATE_FORFAIT, item.id, data).then((res) => {
            setIsSubmit(false);
            reset();
            if (res.status === 200) {
                document.getElementById('fermer').click()
                toast.success('Forfait mis à jour')
                forfait.forfait({ page: 0, param: "", size: 10 })
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err.response.data.donnee)
        })
    }

    useEffect(() => {
        reset()
        if (item) {
            reset({
                designation: item?.designation,
                offerId: item?.offerId,
                typeEquipementId: item?.typeEquipement?.id,
                categorie: item?.categorie,
                description: item?.description,
            });
        }
    }, [item, reset]);

    useEffect(() => {
        typeEquipements.equipement({ page: 0, param: "", size: 10 })
    }, [])

    return (
        <div>
            <form onSubmit={handleSubmit(submit)} className='px-2'>
                <div className='my-4 space-y-4'>
                    <div className='my-2'>
                        <label htmlFor="" className='text-sm font-medium'>Designation <span className="text-red-500">*</span></label>
                        <input {...register('designation', { required: true })} defaultValue={item?.designation}
                            className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        />
                        {errors.designation && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                    </div>

                    <div className='my-2'>
                        <label htmlFor="" className='text-sm font-medium'>OfferedId <span className="text-red-500">*</span></label>
                        <input type="text" placeholder="" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                            {...register('offerId', { required: true })} defaultValue={item?.offerId} />
                        {errors.offerId && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                    </div>

                    <div>
                        <label className="text-sm font-medium">Type d'équipement <span className="text-red-500">*</span></label>
                        <select {...register('typeEquipementId', { required: true })} value={typeEquipement} onChange={(e) => setTypeEquipement(e.target.value)} className="select select-bordered w-full h-10">
                            <option disabled selected>
                                type d'équipement
                            </option>
                            {
                                typeEquipements?.data?.equipements?.map((item) => (
                                    <option value={item.id}>{item.designation}</option>
                                ))
                            }
                        </select>
                    </div>


                    <div>
                        <label className="text-sm font-medium">Categorie de forfait <span className="text-red-500">*</span></label>
                        <select  {...register('categorie', { required: true })} value={categorie} onChange={(e) => setCateogie(e.target.value)} className="select select-bordered w-full h-10">
                            <option disabled selected>
                            </option>
                            <option value="PRE_PAID">
                                Forfait prepayé
                            </option>
                            <option value="POST_PAID">
                                Forfait postpayé
                            </option>
                        </select>
                    </div>


                    <div className='my-2'>
                        <label className="font-medium text-sm">Description</label>
                        <textarea {...register('description')} defaultValue={item?.description} className="textarea textarea-bordered w-full" placeholder='Avantage du forfait'></textarea>
                    </div>

                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                        {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>
            </form >
        </div >
    )
}
